import React, { useState } from "react";
import { Modal, Button, Form, Dropdown, DropdownButton, DropdownItem } from "react-bootstrap";
import emailjs from "emailjs-com"; // Import EmailJS
import { sendRequest } from '../../apis/APIs';
import { handleApiResponse } from '../../apis/apiUtils';
import { useSelector, useDispatch } from 'react-redux';
import { callCommonAction } from '../../redux/Common/CommonReducer';
import ActionBtnWithSpinner from "../../common/actionBtnWithSpinner";


const SendEmailPopup = ({ showPopup, setShowModal, file, pdfBytes, users }) => {
    console.log(users, "showPopup")
    const [email, setEmail] = useState(""); // Email entered by the user
    const [error, setError] = useState(""); // Error message for email validation
    const { loading } = useSelector((state) => state.common);
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState(''); // Default dropdown value

    const [dropdownDisabled, setDropdownDisabled] = useState(false);


    // Handle dropdown selection change
    const handleSelect = (selected) => {
        setSelectedOption(selected);
        const user = users.find(user => user.name === selected);
        if (user) {
            setEmail(user.email);
        }
    };
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value === "" || emailRegex.test(value)) {
            setError("");
        } else {
            setError("Please enter a valid email address");
        }

        // Check if entered email matches any user's email, if not, disable dropdown
        const emailExists = users.some(user => user.email === value);
        console.log(emailExists,"emailExistsemailExistsemailExists")
        setDropdownDisabled(value !== '' && !emailExists);
    };





    const handleSendEmail = async (e) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setError("Please enter a email address");
            return;
        }
        try {
            dispatch(callCommonAction({ loading: true }));

            const blob = new Blob([pdfBytes], { type: "application/pdf" })
            const file = new File([blob], `${"edited"}.pdf`, {
                type: "application/pdf",
            })
            const formData = new FormData();
            formData.append("file", file); // `file` must be a File object from <input type="file" />
            formData.append("email", email); // `file` must be a File object from <input type="file" />

            const res = await sendRequest('/user/send-proposal-email', 'POST', formData);
            // Don't set Content-Type manually – the browser will handle it correctly
            dispatch(callCommonAction({ loading: false }));

            handleApiResponse(res);

            if (res.data.type === 'success') {
                dispatch(callCommonAction({ loading: false }));
                setShowModal(false)
                console.log("Email sent successfully");
            }
        } catch (error) {
            console.error("Failed to send email:", error);
            dispatch(callCommonAction({ loading: false }));

            // toast.error(error?.response?.data?.message || "Error sending email");
        }
    };


    return (
        <Modal show={showPopup} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title className="fs-6">Send Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Dropdown */}
                    <Form.Group className="mb-3">
                        <Form.Label>Select User</Form.Label>
                        <DropdownButton
                        className="fs-14"
                            id="dropdown-custom-components"
                            title={selectedOption || "Select User"}
                            onSelect={handleSelect}
                            disabled={dropdownDisabled} // Disable dropdown if email does not match
                        >
                            {users.map((user) => (
                                <Dropdown.Item key={user.id} eventKey={user.name}>
                                    {user.name}
                                </Dropdown.Item>
                            ))}
                        </DropdownButton>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter recipient's email"
                            value={email}
                            onChange={handleEmailChange}
                            isInvalid={!!error}
                        />
                        {error && <div className="text-danger">{error}</div>}
                    </Form.Group>

                </Form>

            </Modal.Body>
            <Modal.Footer>


                <button onClick={() => setShowModal(false)} class="btn btn-outline-custom btn-sm px-3 py-2 rounded-3">Close</button>
                <div class="">
                    <button type="submit" onClick={handleSendEmail} disabled={loading} className="  btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3">
                        {
                            loading
                                ? <span className="indicator-progress " style={{ display: 'block' }}>
                                    Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                : <span className="text-uppercase d-flex align-items-center"> <iconify-icon icon="material-symbols:upload-rounded" class="fs-5"></iconify-icon>Send</span>
                        }
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default SendEmailPopup;
